
import { CreditCard } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
// import { UserType } from '../../../globals';
import { RootState, useAppSelector } from '@/utils/storage/stores/store.ts';

const BonusCard = () => {
  const user = useAppSelector((state: RootState) => state.user.userInfo);

  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <h3 className="mb-4 text-xl font-bold">Бонусная программа</h3>
      
      <div className="mb-6 overflow-hidden rounded-lg bg-gradient-to-r from-autoparts-orange to-orange-500 p-4 text-white shadow-md">
        <div className="flex justify-between">
          <div>
            <p className="mb-1 text-sm opacity-80">Доступно бонусов</p>
            <p className="text-3xl font-bold">{user ? new Intl.NumberFormat('ru-RU').format(user.bonusBalance || 0) : 0}</p>
          </div>
          <CreditCard className="h-16 w-16 opacity-30" />
        </div>
      </div>
      
      <p className="mb-4 text-sm text-gray-600">
        Получайте 3% от суммы каждого заказа в виде бонусов. Бонусами можно оплатить до 10% стоимости заказа.
      </p>
      
      <Link to="/bonus">
        <Button variant="outline" className="bonus-card-button border-autoparts-orange text-autoparts-orange hover:bg-autoparts-orange hover:text-white">
          Условия бонусной программы
        </Button>
      </Link>
    </div>
  );
};

export default BonusCard;
